import { useId } from 'react'
import { range } from '@/utils/functions/range'
import { cn } from '@/utils/styles/cn'

interface IRestaurantPriceRangeProps {
    className?: string
    filledColorClassName?: string
    emptyColorClassName?: string
    currencySymbol: string | null
    priceRange: number | null
}

export const RestaurantPriceRange = ({
    className,
    filledColorClassName = 'text-black/100 font-normal',
    emptyColorClassName = 'text-black/40 font-normal',
    currencySymbol,
    priceRange: rawPriceRange,
}: IRestaurantPriceRangeProps) => {
    const componentId = useId()

    if (rawPriceRange === null) return null

    const priceRange = rawPriceRange || 1

    return (
        <div className={cn('flex flex-row gap-[0.5px] items-center text-[inherit]', className)}>
            {range(4).map((_, index) => {
                const isFilled = index <= priceRange - 1

                return (
                    <span
                        key={index + 'restaurant-card' + componentId + 'price-dot'}
                        className={cn(
                            'text-[inherit]',
                            isFilled ? filledColorClassName : emptyColorClassName
                        )}
                    >
                        {currencySymbol}
                    </span>
                )
            })}
        </div>
    )
}
